module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_001_small.4ce60eb3.jpg";